import { FeedIcon } from './icons/FeedIcon';
import { LiveIcon } from './icons/LiveIcon';
import { LoyaltyIcon } from './icons/LoyaltyIcon';
import { PortfolioIcon } from './icons/PortfolioIcon';
import { WalletIcon } from './icons/WalletIcon';

/** Describes a single navigation tab, shared by the mobile bottom bar and the desktop sidebar. */
export interface NavItem {
  id: string;
  label: string;
  /**
   * Icon component for the tab. Receives `active` so it can play its
   * subject-themed select animation when this tab becomes active.
   */
  Icon: React.ComponentType<{ className?: string; active?: boolean }>;
  /** Route this tab navigates to when tapped. */
  path: string;
  /**
   * Text-color class for the ACTIVE state, when the tab deviates from the
   * default brand purple (the Live tab goes red, matching its page/badge).
   */
  activeClassName?: string;
}

const feed: NavItem = { id: 'feed', label: 'Feed', Icon: FeedIcon, path: '/' };
const wallet: NavItem = { id: 'wallet', label: 'Wallet', Icon: WalletIcon, path: '/wallet' };
const portfolio: NavItem = { id: 'portfolio', label: 'Portfolio', Icon: PortfolioIcon, path: '/portfolio' };
// Live selects in red (Figma live tab) — the same red as the live card badge.
const live: NavItem = { id: 'live', label: 'Live', Icon: LiveIcon, path: '/live', activeClassName: 'text-danger-alt' };
const loyalty: NavItem = { id: 'loyalty', label: 'Loyalty', Icon: LoyaltyIcon, path: '/loyalty' };

/** Mobile bottom-bar order — Feed is deliberately the center tab. */
export const bottomNavItems: NavItem[] = [wallet, portfolio, feed, live, loyalty];

/** Desktop sidebar order (Figma "Side menu") — Feed first. */
export const sideNavItems: NavItem[] = [feed, wallet, portfolio, live, loyalty];

/**
 * Resolve which nav tab to highlight for a given route. Falls back to a
 * path-based match, then to `"feed"` for unknown routes.
 */
export function resolveActiveItem(pathname: string): string {
  const match = bottomNavItems.find((item) => item.path !== '/' && pathname.startsWith(item.path));
  if (match) return match.id;
  return 'feed';
}
